import { GzTimePickerWebComponent } from '../../gzTimePicker';
import { ValidationResult } from '../formField/types/form-validator';
import { SelectedTime } from '../../gzTimePicker/types';

export const TimeIntervalValidator = (startTimeComponent: GzTimePickerWebComponent, errorMessage: string) => {
  return async (endTime: SelectedTime): Promise<ValidationResult> => {
    const startTime: SelectedTime = startTimeComponent.getFormValue();

    if (!startTime || !endTime) {
      return { valid: false, error: errorMessage };
    }

    do {
      if (startTime.hours < endTime.hours) {
        break;
      }

      if (startTime.hours === endTime.hours && startTime.minutes < endTime.minutes) {
        break;
      }

      return { valid: false, error: errorMessage };
    } while (false);

    return { valid: true };
  };
};
